<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <b-link
        class="ml-25"
        href="javascript:void(0)"
      >Neio network</b-link>
      <span class="d-none d-sm-inline-block">, {{ $t('All rights Reserved') }}</span>
    </span>

    <span class="float-md-right">
      <dark-Toggler class="d-none d-lg-block" />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import DarkToggler from './app-navbar/components/DarkToggler.vue'

export default {
  components: {
    BLink,
    DarkToggler,
  },
}
</script>
